import blogImg1 from '../assets/images/blog/blog-img1.webp';
import blogImg2 from '../assets/images/blog/blog-img2.webp';
import blogImg3 from '../assets/images/blog/blog-img3.webp';
import blogImg4 from '../assets/images/blog/blog-img4.webp';
import blogImg5 from '../assets/images/blog/blog-img5.webp';
import blogImg6 from '../assets/images/blog/blog-img6.webp';

const BlogList = [
  {
    id: 1,
    postType: 'sticky-post',
    imgSrc: blogImg1,
    title: 'From a small startup to a leading global agency in 10 Years.',
    category: 'Strategy',
    date: 'Jan 15, 2023',
    description:
      'Imagine that a few more steps ahead there is a place where the path splits, where is goes off to the left and off to the right. Pause here for a few moments and have a think. Here, there are two different pathways, two possibilities, two ways that you could choose to go.',
    mainDescription:
      'You carry on doing the same things, living the same way and dealing with this thing in the same way as you have been doing. If you were choose the path to the right, the right path, there are new possibilities, achievement, freedom of mind, positive and progressive implications. Think about that as you stand at this place where the path splits. You want to make a decision and commit to one of these paths. Before you make that decision, we are going to see what each path holds for your future.',
  },
  {
    id: 2,
    imgSrc: blogImg2,
    title: "How google's BERT algorithm affects your website traffic",
    category: 'Jobs',
    date: 'Jan 30, 2023',
    description:
      "The first thing to remember about success is that it is a process - nothing more, nothing less. There is really no magic to it and it's not reserved only for a select few people. It really comes down to understanding the steps in the process and then executing on those steps.",
    mainDescription:
      'You carry on doing the same things, living the same way and dealing with this thing in the same way as you have been doing. If you were choose the path to the right, the right path, there are new possibilities, achievement, freedom of mind, positive and progressive implications. Think about that as you stand at this place where the path splits. You want to make a decision and commit to one of these paths. Before you make that decision, we are going to see what each path holds for your future.',
  },
  {
    id: 3,
    imgSrc: blogImg3,
    title: 'Five reasons why you must create a website for your company',
    category: 'Technology',
    date: 'Feb 15, 2023',
    description:
      'There are basically six key areas to higher achievement. Some people will tell you there are four while others may tell you there are eight. One thing for certain though, is that irrespective of the number of steps the experts talk about, they all originate from the same roots.',
    mainDescription:
      'You carry on doing the same things, living the same way and dealing with this thing in the same way as you have been doing. If you were choose the path to the right, the right path, there are new possibilities, achievement, freedom of mind, positive and progressive implications. Think about that as you stand at this place where the path splits. You want to make a decision and commit to one of these paths. Before you make that decision, we are going to see what each path holds for your future.',
  },
  {
    id: 4,
    imgSrc: blogImg4,
    title:
      'Corporations that Prove Data is Key to Victorious Digital Transformation',
    category: 'Marketing',
    date: 'Feb 28, 2023',
    description:
      'Making a decision to do something - this is the first step. We all know that nothing moves until someone makes a decision. The first action is always in making the decision to proceed. This is a fundamental step, which most people overlook.',
    mainDescription:
      'You carry on doing the same things, living the same way and dealing with this thing in the same way as you have been doing. If you were choose the path to the right, the right path, there are new possibilities, achievement, freedom of mind, positive and progressive implications. Think about that as you stand at this place where the path splits. You want to make a decision and commit to one of these paths. Before you make that decision, we are going to see what each path holds for your future.',
  },
  {
    id: 5,
    imgSrc: blogImg5,
    title: 'Google, Facebook or Instagram Which one is best for my business?',
    category: 'Finance',
    date: 'Mar 15, 2023',
    description:
      "There is really no magic to it and it's not reserved only for a select few people. As such, success really has nothing to do with luck, coincidence or fate. It really comes down to understanding the steps in the process and then executing on those steps.",
    mainDescription:
      'You carry on doing the same things, living the same way and dealing with this thing in the same way as you have been doing. If you were choose the path to the right, the right path, there are new possibilities, achievement, freedom of mind, positive and progressive implications. Think about that as you stand at this place where the path splits. You want to make a decision and commit to one of these paths. Before you make that decision, we are going to see what each path holds for your future.',
  },
  {
    id: 6,
    imgSrc: blogImg6,
    title: 'Five initial steps you must do to increase your business incomes',
    category: 'Operations',
    date: 'Mar 30, 2023',
    description:
      "There is really no magic to it and it's not reserved only for a select few people. The first thing to remember about success is that it is a process - nothing more, nothing less. It really comes down to understanding the steps in the process and then executing on those steps.",
    mainDescription:
      'You carry on doing the same things, living the same way and dealing with this thing in the same way as you have been doing. If you were choose the path to the right, the right path, there are new possibilities, achievement, freedom of mind, positive and progressive implications. Think about that as you stand at this place where the path splits. You want to make a decision and commit to one of these paths. Before you make that decision, we are going to see what each path holds for your future.',
  },
];

export default BlogList;
